// World 1 (Threshold) — L1–L4 are hand-authored tutorials that teach the
// chain-annihilation mechanic (docs/mechanics.md §4 step 5); L5+ come from
// the generator + solver pipeline (see tools/generate-world1.mjs and
// packages/generator/).
import type { LevelDef } from '@tessera/engine';
import { WORLD_1_GENERATED } from './world1-generated';

const HANDCRAFTED: LevelDef[] = [
  // L1 — intro. One slide: mover at (3,-1) slides W, stops at (2,-1) next to normal (1,-1),
  // forming a 3-group {charged (0,0), normal (1,-1), normal (2,-1)} → chain 2 → annihilate.
  {
    id: 'w1-l01',
    world: 1,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 2 },
    tiles: [
      { coord: { q: 0, r:  0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
      { coord: { q: 1, r: -1 }, color: 0 },
      { coord: { q: 3, r: -1 }, color: 0 },
    ],
  },
  // L2 — two slides. Slide (2,0) W to (1,0); then slide (0,2) NW to (0,1).
  // Forms triangle {charged (0,0), (1,0), (0,1)} → chain 2 → annihilate.
  {
    id: 'w1-l02',
    world: 1,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 3 },
    tiles: [
      { coord: { q: 0, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
      { coord: { q: 2, r: 0 }, color: 0 },
      { coord: { q: 0, r: 2 }, color: 0 },
    ],
  },
  // L3 — two colors, four slides. Two identical sub-puzzles stacked: clear each color line
  // by sliding inner tile E, then bringing the charged tile in E to complete a 3-group.
  {
    id: 'w1-l03',
    world: 1,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
      { coord: { q: -2, r:  0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
      { coord: { q:  0, r:  0 }, color: 0 },
      { coord: { q:  2, r:  0 }, color: 0 },
      { coord: { q: -2, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
      { coord: { q:  0, r: -1 }, color: 1 },
      { coord: { q:  2, r: -1 }, color: 1 },
    ],
  },
  // L4 — diagonal 2-move. Normals at opposite corners slide toward the charged
  // in center; second slide closes the triangle → chain-2 annihilate.
  {
    id: 'w1-l04',
    world: 1,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 3 },
    tiles: [
      { coord: { q:  0, r:  0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
      { coord: { q:  2, r: -2 }, color: 0 },
      { coord: { q: -2, r:  2 }, color: 0 },
    ],
  },
];

export const WORLD_1_LEVELS: LevelDef[] = [...HANDCRAFTED, ...WORLD_1_GENERATED];
